module.exports = __webpack_public_path__ + "static/media/PoopBag.3048ae9c.png";